<template>
  <div class="outside">
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="11" :lg="11">
          <div class="figure">
            <i class="icon icon-user"></i>
          </div>
        </el-col>
        <el-col :xs="24" :sm="13" :lg="13">
          <h2 class="text-light-blue">Iniciar Sesion</h2>
          <el-form :model="model">
            <el-form-item class="twin-top">
              <el-input v-model="model.username"

                        placeholder="nombre de usuario"></el-input>
            </el-form-item>
            <el-form-item class="twin-bottom">
              <el-input v-model="model.password"
                        type="password"
                        placeholder="contraseña"></el-input>
            </el-form-item>
            <el-button type="primary"
                       class="pull-right"
                       :disabled="!model.password || !model.username || processing"
                       @click="login">
              <span v-if="!processing">ENTRAR</span>
              <span v-else>VERIFICANDO...</span>
            </el-button>
          </el-form>
        </el-col>
      </el-row>

      <el-alert
        v-if="error"
        class="mt-1"
        :title="error"
        type="error">
      </el-alert>
      <router-link to="email" class="text-dark-gray mt-1">¿Olvide la contrase&ntilde;a?</router-link>
    </el-card>
  </div>
</template>

<script>
  import {baseUrl, clientId, clientSecret} from '../../configs/urls'
  import {parseError} from '../../packages/Helpers'

  export default {
    name: 'Login',
    data () {
      return {
        processing: false,
        error: '',
        model: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      login () {
        const data = {
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: 'password',
          username: this.model.username,
          password: this.model.password
        }

        this.processing = true
        this.error = ''

        this.$http.post(baseUrl + '/oauth/token', data)
          .then(
            (response) => {
              const body = response.body
              this.$auth.setToken(body.access_token, body.expires_in)
              this.$router.push('/dashboard')
              this.processing = false
            },
            (res) => {
              [this.error] = parseError(res)
              this.processing = false
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue